<template>
  <div
    :id="item.id"
    class="w-full"
    :class="{ 'is-active': accordionItem.active }"
  >
    <dt
      class="flex relative justify-between items-center px-5 py-3 mb-5 w-full text-xl bg-white rounded-lg shadow-md cursor-pointer"
    >
      <span
        class="text-base font-bold"
        @click="toggle(accordionItem.id)"
      >
        {{ accordionItem.title }}
      </span>
      <div
        class="mb-1 plus"
        :class="{ minus: activeItem == accordionItem.id }"
        @click="toggle(accordionItem.id)"
      ></div>
      <!-- <div @click="toggle(accordionItem.id)" class="my-auto">
                {{ activeItem == accordionItem.id ? '-' : '+' }}
            </div> -->
    </dt>
    <transition
      name="accordion-item"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <dd v-show="accordionItem.active" class="accordion-item-details">
        <div class="accordion-item-details-inner">
          <div
            class="max-w-full prose"
            v-html="accordion.text"
          ></div>
        </div>
      </dd>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AccordionItem",
  props: {
    item: {
      type: Object,
      default: Object,
    },
    groupId: {
      type: String,
      default: String,
    },
  },
  data() {
    return {
      accordionItem: this.item,
      activeItem: 0,
    };
  },
  methods: {
    toggle(id) {
      this.activeItem = this.activeItem == 0 ? id : 0;
      this.$parent.$children.forEach((accordion) => {
        let parentId = accordion.$el.id ? parseInt(accordion.$el.id) : null;
        let currentId = this.accordionItem.id
          ? parseInt(this.accordionItem.id)
          : null;
        if (parentId && currentId && parentId === currentId) {
          // eslint-disable-next-line prettier/prettier
          accordion.accordionItem.active = !accordion.accordionItem.active;
        } else {
          accordion.accordionItem.active = false;
        }
      });
    },

    startTransition(el) {
      el.style.height = el.scrollHeight + "px";
    },

    endTransition(el) {
      el.style.height = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion {
  list-style: none;
  margin: 0;
  padding: 0;
  .accordion-item {
    @apply mb-2;
  }
  &__item:last-child {
    border-bottom: none;
  }

  dd {
    margin-left: 0;
  }
}
.accordion-item-trigger-icon {
  width: 8px;
  height: 8px;
  @apply border-r-2 border-b-2 m-auto top-0 bottom-0 right-0 absolute block;
  transform: translateY(-8px / 4) rotate(45deg);
  transition: transform 0.2s ease;

  .is-active & {
    transform: translateY(8px / 4) rotate(225deg);
  }
}

.plus {
  display: inline-block;
  width: 30px;
  height: 30px;
  background: linear-gradient(#00415a, #00415a),
    linear-gradient(#00415a, #00415a);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 50% 1px, 1px 50%; /*thickness = 2px, length = 50% (25px)*/
  &.minus {
    background-size: 50% 1px, 0px 50%; /*thickness = 2px, length = 50% (25px)*/
  }
}

.accordion-item-enter-active,
.accordion-item-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.accordion-item-enter,
.accordion-item-leave-to {
  height: 0 !important;
}
</style>
